import React from "react";
import { PromotionCreateForm } from "@components";

const PromotionCreate = ({ history }) => {
  return (
    <div style={{ minHeight: "100vh", background: "#f5f5f5" }}>
      <PromotionCreateForm />
    </div>
  );
};

export default PromotionCreate;
